import React, { useState } from 'react'
import { useTranslation } from 'react-i18next';
import { MenuList,MenuItem,Paper } from '@mui/material'
import ContextMenu from './ContextMenu'

const RECORD_MAPPING = {
  MNU_NEW_REC_MAPPING: 'MNU_NEW_REC_MAPPING',
  MNU_NEW_COMP_REC_MAPPING: 'MNU_NEW_COMP_REC_MAPPING',
  MNU_DEL_SEL_REC_MAPPING: 'MNU_DEL_SEL_REC_MAPPING',
};

export default function RecordMappingContextMenu({
  onCreateRecordMap = () => {},
  onCreateCompoundRecordMap = () => {},
  onDeleteRecordMap = () => {},
  hasRecordMappings = false,
  hasSelectedMapping = false
}) {
  const { t } = useTranslation();
  const handleClick = (action) => () => {
    if(action === RECORD_MAPPING.MNU_NEW_REC_MAPPING) onCreateRecordMap();
    else if(action === RECORD_MAPPING.MNU_NEW_COMP_REC_MAPPING) onCreateCompoundRecordMap();
    else if(action === RECORD_MAPPING.MNU_DEL_SEL_REC_MAPPING) onDeleteRecordMap();
  }

  return (
    <>
      <ContextMenu targetId='recordMapping'>
        <Paper style={{ width: '19rem' }}>
        <MenuList vertical='true' >
          <MenuItem
            name={t('MNU_NEW_REC_MAPPING')}
            onClick={handleClick(RECORD_MAPPING.MNU_NEW_REC_MAPPING)}
          >
            <span className={'RECORD_MAPPING'}></span>
            <span className={'margin-left-8'}>{t('MNU_NEW_REC_MAPPING')}</span>
          </MenuItem>
          <MenuItem
            name={t('MNU_NEW_COMP_REC_MAPPING')}
            onClick={handleClick(RECORD_MAPPING.MNU_NEW_COMP_REC_MAPPING)}
          >
            <span className={'NETWORK_FOLDER'}></span>
            <span className={'margin-left-8'} >{t('MNU_NEW_COMP_REC_MAPPING')}</span>
          </MenuItem>
          {hasRecordMappings && hasSelectedMapping && (
            <MenuItem
              name={t('MNU_DEL_SEL_REC_MAPPING')}
              onClick={handleClick(RECORD_MAPPING.MNU_DEL_SEL_REC_MAPPING)}
            >
              <span className={'SYMBOL_DELETE'}></span>
              <span className={'margin-left-8'}>{t('MNU_DEL_SEL_REC_MAPPING')}</span>
            </MenuItem>
          )}
        </MenuList>
        </Paper>
      </ContextMenu>
    </>
  )
}
